import {
  Button, Card, CardActions, CardContent, CardHeader, TextField,
  CircularProgress, Dialog, Grid, DialogActions, DialogContent,
  DialogContentText, DialogTitle, Divider, IconButton, Typography,
  List, ListItem, ListItemText, MenuItem, createMuiTheme, ListItemSecondaryAction,
  ListItemAvatar, Avatar
} from '@material-ui/core';
import DateRangeIcon from '@material-ui/icons/DateRange';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import NotListedLocationIcon from '@material-ui/icons/NotListedLocation';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import axios from 'src/utils/axios';
import { getKoordinat, getUser } from 'src/utils/Common';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import FgsArama from '../views/Overview/FgsCall';
import CustomerPermision from './CustomerPermision';
import AppReasonSearch from './Selects/AppReasonSearch';
import RetailerSearch from './Selects/RetailerSearch';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import SendIcon from '@material-ui/icons/Send';
import ScheduleIcon from '@material-ui/icons/Schedule';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import PinterestIcon from '@material-ui/icons/Pinterest';
import RedditIcon from '@material-ui/icons/Reddit';
import YouTubeIcon from '@material-ui/icons/YouTube';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import DateFnsUtils from '@date-io/date-fns';
import Alert from 'src/components/Alert';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import { setTask } from 'src/store/actions/taskActions';
import AlarmIcon from '@material-ui/icons/Alarm';
import CancelIcon from '@material-ui/icons/Cancel';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    overflowY: 'auto',
    minHeight: '500px',
  },
  submitButton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },

}));
const siyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});

const localeMap = {
  tr: trLocale
};

function CustomerInfo({
  customer, readonly, ReceiptNoParam, tasks, className, setTask, ...rest
}) {
  const [open1, setOpen1] = React.useState(false);
  const [Uyari, setUyari] = React.useState('');
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [openEdit, setOpenEdit] = useState(false);
  const [openFgsArama, setOpenFgsArama] = useState(false);
  const [ReceiptNo, setReceiptNo] = useState('');
  const [data, setData] = useState({});
  const [SocialMedia, setSocialMedia] = useState(false);
  const [SecretNote, setSecretNote] = useState('');
  const [dataBn, setDataBn] = useState({ IssueReason: '' });
  const [uyariAlert, setuyariAlert] = useState(false);
  const [open, setOpen] = React.useState(false);
  const locale = localStorage.getItem('i18nextLng');
  const [MusteriBilgileri, setMusteriBilgileri] = React.useState('');
  const [newBasvuru, setNewBasvuru] = useState('');
  const [loading, setLoading] = useState(false);
  const [CustomerSecretNote, setCustomerSecretNote] = useState(false);
  const [CustomerAppointment, setCustomerAppointment] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [LoadingControl, setLoadingControl] = useState(false);
  const [SecretNoteData, setSecretNoteData] = useState([]);
  const [VulnerabilitiesId, setVulnerabilitiesId] = useState(0);
  const [VulnerabilitiesData, setVulnerabilitiesData] = useState([]);
  const localizer = momentLocalizer(moment);
  const [AppointmentDate, setAppointmentDate] = useState(null);
  const [AppointmentDateEvent, setAppointmentDateEvent] = useState([]);
  const SessionUser = getUser();
  const [NewAppointment, setNewAppointment] = useState(null);
  const SonlandirData = tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNoParam));
  const [showInternalNotes, setShowInternalNotes] = useState(true);
  const isOnline = useSelector((state) => state.status?.isOnline);


  const handleShowInternalNotesOnChange = e => {
    setShowInternalNotes(!showInternalNotes);
  }

  const setIssue = (param) => {
    setNewBasvuru(param.Id);
    setDataBn({ IssueReason: param.Dsc, IssueReasonId: param.Id });
  };
  const search = '';

  useEffect(() => {
    const storeData = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNoParam)) : loadBaslandiJob();
    if (storeData.length !== 0) {
      setData(storeData[0]);
    } else {
      setData({});
    }
  }, [ReceiptNo, tasks.tasks, readonly]);


  const setRetailer = (param) => {
    if (readonly) {
      return;
    } else {
      let job = loadBaslandiJob()[0];
      job = {
        ...job,
        RetailerDescription: param.Dsc,
        RetailerId: param.Id,
      };
      saveBaslandiJob(job);
      setData(job);
      setTask(job);
    }
  };


  const handleEditOpen = () => {
    setOpenEdit(true);
  };
  const HaritaAc = (event, Enlem, Boylam) => {
    window.open(`${process.env.REACT_APP_MAP_URL + Enlem},${Boylam}`);
    event.persist();
  };



  const handleEditClose = () => {
    setOpenEdit(false);
  };

  const handleFgsAramaOpen = (event, AtananIsReceiptNo) => {
    setOpenFgsArama(true);
    setReceiptNo(AtananIsReceiptNo.toString());
  };
  const handleFgsAramaClose = () => {
    setOpenFgsArama(false);
  };
  const handleCloseS = () => {
    setSocialMedia(false);
  };
  const handleCloseCustomerSecretNote = () => {
    setCustomerSecretNote(false);
  };

  const handleCloseCustomerAppointment = () => {
    setCustomerAppointment(false);
  };

  const handleSelect = (event) => {
    const FormatAppointmentDate = moment(event.slots[0]).format(
      'YYYY-MM-DDTHH:mm:ss'
    );

  };


  const setBayi = (param) => {
    if (readonly) {
      return;
    }
    let job = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNoParam))[0] : loadBaslandiJob()[0];
    job = {
      ...job,
      KUL_BAYI_KODU: param.KUL_BAYI_KODU,
      BAYI_ACIKLAMA: param.ACIKLAMA,
      BAYI_KODU: param.BAYI_KODU,
    };
    saveBaslandiJob(job);
    setData(job);
  };

  const statusUpdate = (job, newStatus) => {
    if (newBasvuru === undefined || newBasvuru === '') {
      setUyari(t('Basvuru_Nedeni_Seciniz'));
      setOpen1(true);
      return;
    }
    setLoading(true);
    const dataReq = [{
      IssueId: newBasvuru,
      WorkOrderId: job.ReceiptNo,
      ConsumerId: job.ConsumerId,
      ServiceShopId: job.ServiceShopId,
      EmployeeId: job.TechnicianId,
      ProductId: 0,
      Latitude: getKoordinat('Enlem'),
      Longitude: getKoordinat('Boylam'),
      AppointmentDate
    }];


    const config = {
      headers: { 'Content-Type': 'application/json' }
    };


    axios.post('/SetConnectWorkOrderCreate', dataReq, config).then((response) => {
      const ResponseData = response.data[0];
      setUyari(ResponseData.ErrorDescription);
      setOpen1(true);
      setLoading(false);
      handleClose();
    }).catch((error) => {

      setLoading(false);
    });
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseP = () => {
    setOpen1(false);
  };
  const handleClickOpen = (job, newStatus) => {
    setOpen(true);
    setMusteriBilgileri(t('Musteri_olustur').replace('@Musteri', job.CustomerFullName));
  };
  const handleChangeSecretNote = (e) => {
    setSecretNote(e.target.value);
  };
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
    setuyariAlert(false);
  };
  const GetSecretNote = () => {
    setLoadingControl(true);
    axios.get(`/GetConsumerSecretNote/${customer.CustomerNo}`)
      .then((response) => {
        const Deger = response.data;
        if (Deger.length === 0) {
          setSecretNoteData([]);
        } else {
          setSecretNoteData(Deger);
        }
        setLoadingControl(false);
      }).catch((error) => {
        setSecretNoteData([]);
        setLoadingControl(false);
      });
  };

  const handleSendCostumerSecretNote = () => {
    if (SecretNote.length === 0) {
      setUyariTip('error');
      setUyariAciklama(t('yorum_yaziniz'));
      setuyariAlert(true);
      return;
    }

    const data = {
      ConsumerId: customer.CustomerNo,
      EmployeeId: parseInt(SessionUser.TechnicianId) || 1,
      SecretNote: SecretNote || '',
      VulnerabilitiesId: VulnerabilitiesId || 0
    };

    const config1 = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoadingControl(true);
    axios.post('/SetConsumerSecretNote', data, config1)
      .then((response) => {
        setLoadingControl(false);
        const ResponseData1 = response.data;
        if (parseInt(ResponseData1.ErrorCode) !== 0) {
          setUyariTip('error');
          setUyariAciklama(ResponseData1.ErrorDescription);
        } else {
          setUyariTip('success');
          setUyariAciklama(ResponseData1.ErrorDescription);
          GetSecretNote();
          setCustomerSecretNote(false);
        }
        setUyari(true);
      }).catch((error) => {
        setLoadingControl(false);
        setUyariTip('error');
        setUyariAciklama(t('Error') + error.message);
        setUyari(true);
      });
  };
  const GetVulnerabilitiesData = () => {
    axios.get('/GetVulnerabilities')
      .then((response) => {
        if (response.data.length > 0) {
          setVulnerabilitiesData(response.data);
        }
      })
      .catch((error) => {

      });
  };

  const GetAppointmentDate = () => {
    axios
      .get(`/GetSchedulingEmployee/${SessionUser.ServiceShopId}`)
      .then((response) => {
        if (response.data.length > 0) {
          const TechnicianData = response.data.filter((d) => parseInt(d.Id) === parseInt(SessionUser.TechnicianId));
          const AppointmentH = [];
          TechnicianData[0].Appointment.forEach((item) => {
            const App1 = new Date(item.start);
            const App2 = new Date(item.end);

            AppointmentH.push({
              title: item.title,
              start: App1,
              end: App2,
            });
          });


          if (AppointmentH.length > 0) {
            setAppointmentDateEvent(AppointmentH);
          }
        }
      })
      .catch((error) => { });
  };


  const updateAppointmentDate = () => {
    const SessionUser = getUser();
    var TimeZone = SessionUser.WriteUTCHour;
    var ResponseDate = new Date(NewAppointment);
    ResponseDate.setHours(ResponseDate.getHours() + parseInt(TimeZone));
    var ResponseDate = moment(ResponseDate).format('YYYY-MM-DDTHH:mm');

    var ResponseDateParam = new Date(NewAppointment);

    if (SonlandirData[0].StatusCode == 42) {
      setLoadingControl(false);
      setUyari(t('appointment_warning'));
      setOpen1(true);
    } else {
      axios.post(`/SetUpdateAppointmentDate/${moment(ResponseDate).format('YYYY-MM-DD HH:mm')}/${ReceiptNoParam}`)
        .then((response) => {
          setuyariAlert(true);
          if (response.data[0].ErrorCode !== '0') {
            setLoadingControl(false);
            setUyariTip('error');
            setUyariAciklama(response.data[0].ErrorDescription);
            setUyari(true);
          }
          else {
            let job = loadBaslandiJob[0];
            job = {
              ...job,
              AppointmentDate: moment(ResponseDateParam).format('YYYY-MM-DDTHH:mm'),
            };
            setTask(job)
            saveBaslandiJob(job);
            setData(job);
            handleCloseCustomerAppointment();
            setUyariTip('success');
            setUyariAciklama(t('success_message'));
            setUyari(true);
          }


        })
        .catch((error) => {
          setLoadingControl(false);
          setUyariTip('error');
          setUyariAciklama(t('Error') + error.message);
          setUyari(true);
        });
    }
  };

  useEffect(() => {
    GetSecretNote();
    GetVulnerabilitiesData();
    GetAppointmentDate();
    // eslint-disable-next-line
  }, []);


  const setAppointmentData = value => {
    setNewAppointment(value);
  };


  return (
    <div>
      <Card
        className={clsx(classes.root, className)}
      >
        <CardHeader
          title={t('Musteri_detay')}
        />
        <Divider />
        <CardContent className={classes.content}>
          <Grid container>
            <Grid item xs={12} sm={6} lg={6}>
              <Typography className={classes.title} color="textSecondary">
                {t('Telefon_Arayan')}
              </Typography>
              <Typography variant="h6" component="h2" gutterBottom>
                {customer ?
                  customer?.ConsumerPhones?.map((AtananIs) => (
                    <div className={classes.wrapper} key={AtananIs.Phone}>
                      {AtananIs.Type}
                      {' '}
                      :+
                      {AtananIs.Phone}
                    </div>
                  )) : ''}
              </Typography>
              <Typography className={classes.title} color="textSecondary">
                {t('Adres')}
              </Typography>
              <Typography variant="h6" component="h2" gutterBottom>
                {customer.Address}
                <br />
                {customer.Neighborhood}
                {' '}
                {customer.Town}
                {' '}
                {customer.City}
              </Typography>
              <Typography className={classes.title} color="textSecondary">
                {t('lblContact')}
              </Typography>
              <Typography variant="h6" component="h2" gutterBottom>
                {customer.ContactName}
                {' '}
                :+
                {customer.ContactPhone}
              </Typography>
              <Typography className={classes.title} color="textSecondary">
                {t('Musteri_tipi')}
              </Typography>
              <Typography variant="h6" component="h2" gutterBottom>
                {customer.CustomerType}
              </Typography>
              <Typography className={classes.title} color="textSecondary">
                {t('Bayi')}
              </Typography>
              <Typography variant="h6" component="h2" gutterBottom>
                <Grid item xs={6} align="left">
                  <RetailerSearch
                    setRetailer={setRetailer}
                    value={{
                      Dsc: data.RetailerDescription || '',
                      Id: data.UserRetailerCode,
                    } || ''}
                    searchParam={search}
                    disabled={!isOnline}
                  />
                </Grid>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} lg={6}>

              <div className={clsx(classes.root, className)}>
                <Card className={classes.contentMin}>
                  <CardHeader
                    title={t('MusteriGizliNot')}
                    action={
                      <IconButton onClick={(event) => setCustomerSecretNote(true)}
                        disabled={!isOnline ? true : SessionUser.TenantId !== 16 ? readonly : false} aria-label='add-comment'>
                        <AddIcon />
                      </IconButton>
                    }
                  />
                  <Divider />
                  {SecretNoteData && SecretNoteData.length > 0 && ((
                    <CardContent className={classes.content}>
                      <List className={classes.root}>
                        {SecretNoteData.map((log) => (
                          <ListItem
                            alignItems="flex-start"
                          >
                            <ListItemText
                              primary=""
                              secondary={(
                                <>
                                  <Typography
                                    component="span"
                                    variant="body1"
                                    className={classes.inline}
                                    color="textPrimary"
                                  >
                                    <b>
                                      {t('Kullanici')}
                                      :
                                    </b>
                                    {' '}
                                    {log.UserSecretNote}
                                    <br />
                                    <b>
                                      {t('Tarih')}
                                      :
                                    </b>
                                    {' '}
                                    {log.Date === undefined ? '' : moment(log.Date).format('DD/MM/YYYY HH:mm')}
                                    <br />
                                    <b>
                                      {t('Mesaj')}
                                      :
                                    </b>
                                    {' '}
                                    {log.SecretNote}
                                  </Typography>
                                </>
                              )}
                            />

                          </ListItem>
                        ))}
                      </List>
                      <Divider />
                    </CardContent>
                  ))}
                </Card>

              </div>

            </Grid>
          </Grid>

        </CardContent>
        <br />
        <Grid container spacing={1}>
          <Grid item xs={6} align="left">
            <Button
              variant="contained"
              color="primary"
              onClick={(event) => HaritaAc(event, customer.Latitude, customer.Longitude)}
              disabled={!isOnline || readonly}
              fullWidth
              endIcon={<NotListedLocationIcon />}
            >
              {t('Yol_Tarifi_Al')}
            </Button>
          </Grid>
          <Grid item xs={6} align="right">
            <Button
              variant="contained"
              color="primary"
              onClick={() => setCustomerAppointment(true)}
              disabled={!isOnline || SessionUser.TenantId === 16}
              fullWidth
              endIcon={<ScheduleIcon />}
            >
              {t('RandevuAl')}
            </Button>
          </Grid>
        </Grid>
        <CustomerPermision
          customer={customer}
          onClose={handleEditClose}
          open={openEdit}
        />
        <FgsArama
          onClose={handleFgsAramaClose}
          ReceiptNo={ReceiptNo}
          open={openFgsArama}
        />
      </Card>
      <br />
      <br />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        {loading ? (
          <CircularProgress
            status="loading"
            style={{ marginLeft: '50%' }}
          />
        )
          : <div />}
        <DialogTitle id="alert-dialog-title">
          {MusteriBilgileri}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="body2" color="textSecondary" gutterBottom>
              {t('Basvuru_Nedeni')}
            </Typography>
            <Typography variant="h6" component="h2">
              <AppReasonSearch
                setIssue={setIssue}
                value={{
                  Dsc: dataBn.IssueReason || '',
                  Id: dataBn.IssueId || 0,
                } || ''}
                searchParam={search}
              />
              <br />
            </Typography>
            <Typography>
              <Calendar
                selectable
                onSelectEvent={(event) => alert(event.title)}
                localizer={localizer}
                events={AppointmentDateEvent}
                toolbar
                step={60}
                style={{ height: 400 }}
                onSelectSlot={handleSelect}
              />
            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={(event) => statusUpdate(customer, 1)}
            disabled={loading}
            className={classes.button}
            endIcon={<AddIcon />}
          >
            {t('Olustur')}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            className={classes.button}
            endIcon={<CloseIcon />}
          >
            {t('iptal')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={open1}
        onClose={handleCloseP}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{t('Bilgilendirme')}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseP} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={SocialMedia}
        fullScreen
        onClose={handleCloseS}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{t('Bilgilendirme')}</DialogTitle>
        <DialogContent>
          <Button
            variant="contained"
            color="primary"
            className={classes.submitButton}
            fullWidth
            // onClick={() => handleFgsAramaYap(item.Phone)}
            endIcon={<WhatsAppIcon>Call</WhatsAppIcon>}
          >
            Whatsapp
          </Button>
          <br />
          <br />
          <Button
            variant="contained"
            color="primary"
            className={classes.submitButton}
            fullWidth
            // onClick={() => handleFgsAramaYap(item.Phone)}
            endIcon={<FacebookIcon>Call</FacebookIcon>}
          >
            Facebook
          </Button>
          <br />
          <br />
          <Button
            variant="contained"
            color="primary"
            className={classes.submitButton}
            fullWidth
            // onClick={() => handleFgsAramaYap(item.Phone)}
            endIcon={<TwitterIcon>Call</TwitterIcon>}
          />
          <br />
          <br />
          <Button
            variant="contained"
            color="primary"
            className={classes.submitButton}
            fullWidth
            // onClick={() => handleFgsAramaYap(item.Phone)}
            endIcon={<InstagramIcon>Call</InstagramIcon>}
          >
            Instagram
          </Button>
          <br />
          <br />
          <Button
            variant="contained"
            color="primary"
            className={classes.submitBuTwittertton}
            fullWidth
            // onClick={() => handleFgsAramaYap(item.Phone)}
            endIcon={<LinkedInIcon>Call</LinkedInIcon>}
          >
            LinkedIn
          </Button>
          <br />
          <br />
          <Button
            variant="contained"
            color="primary"
            className={classes.submitButton}
            fullWidth
            // onClick={() => handleFgsAramaYap(item.Phone)}
            endIcon={<PinterestIcon>Call</PinterestIcon>}
          >
            Pinterest
          </Button>
          <br />
          <br />
          <Button
            variant="contained"
            color="primary"
            className={classes.submitButton}
            fullWidth
            // onClick={() => handleFgsAramaYap(item.Phone)}
            endIcon={<RedditIcon>Call</RedditIcon>}
          >
            Reddit
          </Button>
          <br />
          <br />
          <Button
            variant="contained"
            color="primary"
            className={classes.submitButton}
            fullWidth
            // onClick={() => handleFgsAramaYap(item.Phone)}
            endIcon={<YouTubeIcon>Call</YouTubeIcon>}
          >
            YouTube
          </Button>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseS} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={CustomerSecretNote}
        fullWidth
        onClose={handleCloseCustomerSecretNote}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {' '}
          {t('MusteriGizliNot')}
        </DialogTitle>
        <DialogContent>
          {
            uyariAlert
              ? <Alert onClose={uyariKapat} open={uyariAlert} message={uyariAciklama || ''} variant={uyariTip} />
              : <div />
          }
          {LoadingControl
            ? (
              <CircularProgress
                status="loading"
                style={{ marginLeft: '50%' }}
              />
            )
            : ''}
          <Typography variant="h6" component="h2" gutterBottom>
            <TextField
              size="small"
              fullWidth
              select
              value={VulnerabilitiesId}
              onChange={(event) => setVulnerabilitiesId(event.target.value)}
              variant="outlined"
            >
              {VulnerabilitiesData.map((p) => <MenuItem key={p.Id} value={p.Id}>{p.Dsc}</MenuItem>)}
            </TextField>
          </Typography>
          <Typography variant="h6" component="h2" gutterBottom>
            <TextField
              label={t('MusteriGizliNot')}
              name="Note"
              multiline
              rows={4}
              fullWidth
              value={SecretNote}
              onChange={handleChangeSecretNote}
              variant="outlined"
            />
          </Typography>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSendCostumerSecretNote}
            className={classes.submitButtonComment}
            endIcon={<SendIcon>Gonder</SendIcon>}
          >
            {t('Yorum_Gönder')}
          </Button>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseCustomerSecretNote} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Card>
        <Dialog
          fullScreen
          open={CustomerAppointment}
          onClose={handleCloseCustomerAppointment}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle id="alert-dialog-title">
            {t('Randevu')}
          </DialogTitle>
          <DialogContent>
            {
              uyariAlert
                ? <Alert onClose={uyariKapat} open={uyariAlert} message={uyariAciklama || ''} variant={uyariTip} />
                : <div />
            }
            {LoadingControl
              ? (
                <CircularProgress
                  status="loading"
                  style={{ marginLeft: '50%' }}
                />
              )
              : ''}
            <>
              <Card>
                <CardContent>
                  <b>{SonlandirData[0]?.ContactName}</b>
                  <br />
                  {t('Randevu')}
                  :
                  {' '}
                  <b>
                    {SonlandirData[0]?.AppointmentDate === undefined ? '' : moment(SonlandirData[0]?.AppointmentDate).format('DD/MM/YYYY HH:mm')}
                  </b>
                  <br />
                  <br />
                  <ThemeProvider theme={materialTheme}>
                    <MuiPickersUtilsProvider
                      utils={DateFnsUtils}
                      locale={localeMap[locale]}
                    >
                      <KeyboardDateTimePicker
                        color="primary"
                        fullWidth
                        size="small"
                        ampm={false}
                        inputVariant="outlined"
                        id="WarrantyDate"
                        label={t('lblAppointmentDate')}
                        invalidDateMessage={t('hatali_tarih')}
                        format="dd.MM.yyyy HH.mm"
                        variant="outlined"
                        value={NewAppointment}
                        onChange={e => setAppointmentData(e)}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </ThemeProvider>
                </CardContent>
              </Card>
            </>
            <br />
            <Typography variant="h6" gutterBottom>
              {t('SchedulerWork')}
            </Typography>
            <List className={classes.root}>
              {data?.EmployeeScheduler?.map((log) => (
                <div key={log.AppointmentDate}>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar>
                        <DateRangeIcon />
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                      primary={log.AppointmentDate === undefined ? '' : moment(log.AppointmentDate).format('DD/MM/YYYY HH:mm')}
                      secondary={''}
                    />
                    <ListItemSecondaryAction>
                      <Typography variant="h6" gutterBottom>
                        {log.WorkCount}
                      </Typography>
                    </ListItemSecondaryAction>
                  </ListItem>
                </div>
              ))}
            </List>
          </DialogContent>
          <DialogActions>
            <Grid container spacing={4}>
              <Grid item xs={6} sm={4} lg={6} align="right">
                <Button
                  onClick={(event) => handleCloseCustomerAppointment()}
                  color="primary"
                  variant="contained"
                  endIcon={<CancelIcon />}
                >
                  {t('lblClose')}
                </Button>
              </Grid>
              <Grid item xs={6} sm={4} lg={6}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={(event) => updateAppointmentDate()}
                  endIcon={<AlarmIcon />}
                >
                  {t('lblUpdate')}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>

        </Dialog>
      </Card>
    </div >
  );
}

CustomerInfo.propTypes = {
  className: PropTypes.string,
  customer: PropTypes.object.isRequired
};

export default connect(
  (state) => ({ tasks: state.tasks1 }),
  { setTask }
)(CustomerInfo);
